import React from 'react';
import { Instagram, Facebook, Twitter, MessageCircle, Mail } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#0A0A0A] text-white pt-20 pb-10 px-6 mt-12" data-id="element-33">
      <div className="max-w-7xl mx-auto" data-id="element-34">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 md:gap-8 mb-16" data-id="element-35">
          <div className="md:col-span-1" data-id="element-36">
            <div className="flex items-center gap-2 mb-6" data-id="element-37">
              <div className="w-9 h-9 rounded-md bg-[#FF6B1A] flex items-center justify-center" data-id="element-38">
                <span className="text-white text-lg font-bold leading-none" data-id="element-39">
                  ✈
                </span>
              </div>
              <span className="text-base font-semibold tracking-tight" data-id="element-40">
                IMPORTED <span className="text-[#FF6B1A]" data-id="element-41">FOR YOU</span>.
              </span>
            </div>
            <p className="text-sm text-white/50 font-light leading-relaxed max-w-xs" data-id="element-42">
              Productos importados de calidad, pensados para acompañarte donde
              vayas.
            </p>
          </div>

          <div data-id="element-43">
            <h4 className="font-semibold mb-6 text-sm tracking-wider uppercase" data-id="element-44">
              Navegación
            </h4>
            <ul className="flex flex-col gap-3 text-sm text-white/60 font-light" data-id="element-45">
              <li data-id="element-46">
                <a href="#" className="hover:text-[#FF6B1A] transition-colors" data-id="element-47">
                  Inicio
                </a>
              </li>
              <li data-id="element-48">
                <a href="#detalles" className="hover:text-[#FF6B1A] transition-colors" data-id="element-49">
                  Producto
                </a>
              </li>
              <li data-id="element-50">
                <a href="#oferta" className="hover:text-[#FF6B1A] transition-colors" data-id="element-51">
                  Oferta
                </a>
              </li>
              <li data-id="element-52">
                <a href="#" className="hover:text-[#FF6B1A] transition-colors" data-id="element-53">
                  Reseñas
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-54">
            <h4 className="font-semibold mb-6 text-sm tracking-wider uppercase" data-id="element-55">
              Legal
            </h4>
            <ul className="flex flex-col gap-3 text-sm text-white/60 font-light" data-id="element-56">
              <li data-id="element-57">
                <a href="#" className="hover:text-[#FF6B1A] transition-colors" data-id="element-58">
                  Política de privacidad
                </a>
              </li>
              <li data-id="element-59">
                <a href="#" className="hover:text-[#FF6B1A] transition-colors" data-id="element-60">
                  Términos y condiciones
                </a>
              </li>
              <li data-id="element-61">
                <a href="#" className="hover:text-[#FF6B1A] transition-colors" data-id="element-62">
                  Políticas de envío
                </a>
              </li>
              <li data-id="element-63">
                <a href="#" className="hover:text-[#FF6B1A] transition-colors" data-id="element-64">
                  Garantía
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-65">
            <h4 className="font-semibold mb-6 text-sm tracking-wider uppercase" data-id="element-66">
              Contacto
            </h4>
            <ul className="flex flex-col gap-3 text-sm text-white/60 font-light" data-id="element-67">
              <li data-id="element-68">
                <a href="mailto:imports4.foryou@gmail.com" className="flex items-center gap-2 hover:text-[#FF6B1A] transition-colors" data-id="element-69">
                  <Mail size={14} data-id="element-70" />
                  imports4.foryou@gmail.com
                </a>
              </li>
              <li data-id="element-71">
                <a href="https://wa.me/541131802792" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-[#FF6B1A] transition-colors" data-id="element-72">
                  <MessageCircle size={14} data-id="element-73" />
                  WhatsApp (+54 11 3180-2792)
                </a>
              </li>
            </ul>
            <div className="flex gap-3 mt-6" data-id="element-74">
              <a href="#" aria-label="Instagram" className="w-9 h-9 rounded-full bg-white/5 hover:bg-[#FF6B1A] flex items-center justify-center transition-colors" data-id="element-75">
                <Instagram size={16} strokeWidth={1.5} data-id="element-76" />
              </a>
              <a href="#" aria-label="Facebook" className="w-9 h-9 rounded-full bg-white/5 hover:bg-[#FF6B1A] flex items-center justify-center transition-colors" data-id="element-77">
                <Facebook size={16} strokeWidth={1.5} data-id="element-78" />
              </a>
              <a href="#" aria-label="Twitter" className="w-9 h-9 rounded-full bg-white/5 hover:bg-[#FF6B1A] flex items-center justify-center transition-colors" data-id="element-79">
                <Twitter size={16} strokeWidth={1.5} data-id="element-80" />
              </a>
            </div>
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center pt-8 border-t border-white/10 text-xs text-white/40 font-light gap-2" data-id="element-81">
          <p data-id="element-82">
            © {new Date().getFullYear()} Imported For You. Todos los derechos
            reservados.
          </p>
          <p data-id="element-83">Productos importados con amor 🧡</p>
        </div>
      </div>
    </footer>;
}